import { useMutation } from '@debbie/common/dist/util/hooks.js';
import moment from 'moment';
import React, { useState } from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { Button, ButtonDrop } from '..//index.js';
import ArrowRight from '../Icons/ArrowRight.js';
import Calendar from '../Icons/Calendar.js';
const HistItem = (props) => {
    const [buttonDropOpen, setButtonDropOpen] = useState(false);
    const [loadingOptionIndex, setLoadingOptionIndex] = useState(null);
    const runOption = useMutation((option) => option.onClick(), {
        onError: (error) => alert(error),
        onSettled: () => {
            setLoadingOptionIndex(null);
            setButtonDropOpen(false);
        },
    });
    const fromDate = props.date || (props.timespan && props.timespan.from);
    const toDate = props.timespan && props.timespan.to && props.timespan.to !== fromDate
        ? props.timespan.to
        : null;
    const t = moment(fromDate);
    return (React.createElement("div", { style: {
            minHeight: '65px',
        }, ref: (ref) => (ref = ref) },
        React.createElement(HistItemStyled, null,
            React.createElement(Timeline, { className: `iris-timeline ${props.type ? `iris-timeline-type-${props.type}` : ''}` },
                React.createElement(Badge, null,
                    React.createElement(Calendar, null),
                    React.createElement("div", { className: "iris-timeline-day" }, t.format('DD')),
                    React.createElement("div", { className: "iris-timeline-month" }, t.format('MMM')),
                    React.createElement("div", { className: "iris-timeline-year" }, t.format('YYYY'))),
                React.createElement(TimelineContent, null,
                    fromDate && (React.createElement(Timestamp, null,
                        t.format(THEME.DATE_FORMAT_LONG),
                        toDate ? (React.createElement(React.Fragment, null,
                            ' ',
                            React.createElement(ArrowRight, { style: { margin: '0.2em 0.3em -0.2em' } }),
                            ' ',
                            moment(toDate).format(THEME.DATE_FORMAT_LONG))) : null)),
                    props.options && !!props.options.length && (React.createElement("div", { style: {
                            float: 'right',
                        } },
                        React.createElement(ButtonDrop, { arrow: true, open: buttonDropOpen, onOpen: () => setButtonDropOpen(true), onClose: () => setButtonDropOpen(false) },
                            React.createElement("div", null, props.options &&
                                props.options.map((option, i) => (React.createElement(Button, { block: true, theme: "light", key: option.label, loading: loadingOptionIndex === i, onClick: () => {
                                        setLoadingOptionIndex(i);
                                        runOption.mutate(option);
                                    } }, option.label))))))),
                    props.heading && React.createElement(Heading, null, props.heading),
                    React.createElement(Body, null, props.children))))));
};
export default HistItem;
const HistItemStyled = styled.div ``;
const BADGE_SIZE = 50;
const Badge = styled.div `
  position: sticky;
  width: ${BADGE_SIZE}px;
  height: ${BADGE_SIZE}px;
  margin-left: -50px;

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    margin-left: -40px;
  }

  border-radius: 100%;
  padding: 11px;
  top: 20px;

  &:before {
    content: ' ';
    position: absolute;
    height: 1px;
    width: 1px;
    right: 0px;
    top: 25px;
    border: 4px solid ${THEME.BORDER_STRONG};
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;

    @media ${THEME.MEDIA_QUERY_MOBILE} {
      display: none;
    }
  }

  .iris-timeline-day,
  .iris-timeline-month,
  .iris-timeline-year {
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
  }

  .iris-timeline-day {
    opacity: 0.8;
    margin-bottom: -0.15em;
  }

  .iris-timeline-month {
    font-weight: bold;
    font-size: 0.5em;
    letter-spacing: 0.1em;
  }

  .iris-timeline-year {
    font-size: 0.35em;
    font-weight: bold;
    margin-top: 0px;
    letter-spacing: 0.1em;
  }

  svg {
    height: 24px;
    width: 24px;
    margin-left: 1px;
  }
`;
const Timestamp = styled.div `
  color: ${THEME.DARK_COLOR_SECONDARY};
  font-size: 0.8em;
`;
const Heading = styled.div `
  font-weight: bold;
  margin: 0.2em 0 0.5em 0;
`;
const Body = styled.div ``;
const TimelineContent = styled.div `
  padding-left: ${THEME.GRID_SPACING}px;
  margin-top: -${BADGE_SIZE}px;

  &::after {
    content: '';
    clear: both;
    display: table;
  }

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    padding-left: 10px;
  }
`;
const Timeline = styled.div `
  position: relative;
  margin-left: 40px;
  border-left: 1px solid ${THEME.DARK_COLOR_SECONDARY};
  padding-bottom: ${THEME.GRID_SPACING}px;

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    margin-left: 25px;
  }
`;
//# sourceMappingURL=HistItem.js.map